var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-icon',_vm._g(_vm._b({staticClass:"tn-drag-icon",on:{"mousedown":_vm.mousedown,"touchstart":_vm.touchstart}},'van-icon',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }